import { useMutation } from '@tanstack/react-query';
import type {
  WithdrawSccrsBodyRequest,
  WithdrawSccrsErrorResponse,
  WithdrawSuccessResponse,
} from '@/shared/types';
import { withdrawSccrs } from '@/features/withdraw-sccrs';

interface UseWithdrawSccrsOptions {
  onSuccess?: (data: WithdrawSuccessResponse) => void;
  onError?: (error: WithdrawSccrsErrorResponse) => void;
}

export function useWithdrawSccrs(options?: UseWithdrawSccrsOptions) {
  const mutation = useMutation<
    WithdrawSuccessResponse,
    WithdrawSccrsErrorResponse,
    WithdrawSccrsBodyRequest
  >({
    mutationFn: withdrawSccrs,
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  });

  return {
    ...mutation,
  };
}
